<template>
  <div class="timeline">
    <div class="timeline__progress" :style="`transition-duration: 100ms; width: ${playbackPercentage}%`"></div>
    <div class="timeline__events">
      <div
        v-for="(event, i) in playbackEvents"
        :key="'event' + i"
        class="event"
        :class="[
          {'event--click': event.type === 'click'},
          {'event--drag': event.type === 'dragging'},
        ]"
        :style="`left: ${event.position}%`"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['sessionPlayback'],

  data () {
    return {
      width: 0
    }
  },

  computed: {
    ...mapGetters({
      playbackPercentage: 'interactions/playbackPercentage'
    }),

    playbackLength () {
      return this.sessionPlayback.duration
    },

    playbackEvents () {
      if (this.sessionPlayback.interactions) {
        return this.sessionPlayback.interactions.map(interaction => {
          return {
            position: (interaction.timestamp - this.playbackStartTimestamp) / this.playbackLength * 100,
            type: interaction.type
          }
        })
      }

      return []
    },

    playbackStartTimestamp () {
      return this.sessionPlayback.interactions[0].timestamp
    },
  },

  mounted () {
    setTimeout(() => {
      this.width = 100
    }, 5000)
  }
}
</script>

<style lang="scss" scoped>
.timeline {
  background: rgba(#4d555b, .5);
  height: 1rem;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10002;

  &__progress {
    background: #4d555b;
    height: 100%;
    position: relative;
    transition: all linear;
    width: 0;
  }

  &__events {
    .event {
      // border-radius: 50%;
      height: 100%;
      position: absolute;
      top: calc(50% - .25rem);
      top: 0;
      transform: translateX(-50%);
      width: .2rem;

      &--click {
        background: hotpink;
      }
      &--drag {
        background: greenyellow;
      }
    }
    
    z-index: 10003; 
  }
}
</style>